import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchDashboards} from '../actions/dashboard'
import {fetchVersionsOs} from '../actions/version'
import {fetchVersionsApi} from '../actions/version'
import Dashboard from '../components/Dashboard'

const mapStateToProps = state => {
  const { dashboard } = state
  const { version } = state
  const {
    isFetching,
    lastUpdated,
    items
  } = dashboard || {
    isFetching: true,
    items: []
  }

  const version_info = version?.version_info || "";
  const api_version_info = version?.api_version_info || "";

  return {
    items: items || [],
    // versions,
    version_info,
    api_version_info,
    isFetching,
    lastUpdated
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDashboards: fetchDashboards,
      getVersionsOs: fetchVersionsOs,
      getVersionsApi: fetchVersionsApi,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
